import { mixed, object } from "yup";

import { draftValidationSchema, titleValidationSchema, urlValidationSchema } from "@dzambalaorg/yup-rules";
import { emailValidationSchema } from "@dzambalaorg/yup-rules/dist/email";
import { addressValidationSchema } from "@dzambalaorg/yup-rules-eth";
import { MerchantStatus, RatePlanType } from "@framework/types";

export const merchantsValidationSchema = object().shape({
  title: titleValidationSchema,
  description: draftValidationSchema,
  email: emailValidationSchema,
  wallet: addressValidationSchema,
  imageUrl: urlValidationSchema,
  merchantStatus: mixed<MerchantStatus>()
    .oneOf(Object.values(MerchantStatus))
    .required("form.validations.valueMissing"),
  ratePlan: mixed<RatePlanType>().oneOf(Object.values(RatePlanType)).required("form.validations.valueMissing"),
});
